import * as R from 'remeda';
import { Reducer } from 'redux';
import { getType } from 'typesafe-actions';
import { Stack } from '../../../types/stack';
import { RootActionType } from '../../rootActions';
import { ANNOTATION_STACK } from '../localStorage/actions';
import { startValidation } from '../ui/actions';
import { fetchAnnotationStackFulfilled } from './actions';

export const getCachedStack = () =>
  R.pipe(
    (
      sessionStorage.getItem(ANNOTATION_STACK) ||
      localStorage.getItem(ANNOTATION_STACK) ||
      ''
    ).split(','),
    R.filter(R.isTruthy)
  ).map(Number) || [];

const initialState: Stack = getCachedStack();

const reducer: Reducer<typeof initialState, RootActionType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case getType(fetchAnnotationStackFulfilled):
      return action.payload;

    case getType(startValidation):
      return action.meta.annotationsIds;
    default:
      return state;
  }
};

export default reducer;
